import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Modal, Form, Row, Col, Input, Select, Button, Table, InputNumber } from 'antd'
import {withTranslation} from 'react-i18next'
@inject('marketingManagementStore')
@observer
class FormModal extends Component {
  state = {
    users: '',
    config: [],
    oneVal: null,
    twoVal: null
  }

  formRef = React.createRef()

  componentDidMount() {
    const {marketingManagementStore, title} = this.props
    const {detailsObj} = marketingManagementStore
    marketingManagementStore.getAuditUsers()
    if (title === 'edit') {
      this.formRef.current.setFieldsValue({
        'groupName': detailsObj?.groupName,
        "firstApprover": detailsObj?.firstApprover,
        "secondApprover": detailsObj?.secondApprover,
        "thirdApprover": detailsObj?.thirdApprover,
        "groupMember": detailsObj?.groupMember.map(a=>{return a}),
        "aiMaxConcurrency": detailsObj?.aiMaxConcurrency,
        "config": detailsObj?.config.map(a=>{
          return { 
            ...a, 
            typeName: a?.type==='1' ? '营销短信': a?.type==='2' ? '通知短信': a?.type==='3' ? '邮件' : 
            a?.type==='4' ? '短链'
            // : a?.type==='6' ? '人工外呼' : a?.type==='7' ? '智能外呼' 
            : '企业ID'
          }
        })
      })
      this.setState({
        users: detailsObj?.groupMember.toString(),
        oneVal: detailsObj?.firstApprover,
        twoVal: detailsObj?.secondApprover
      })
    } else {
      this.formRef.current.setFieldsValue({
        "config": [
          {
            key: '',
            appId: '',
            typeName: '营销短信',
            type: '1'
          },
          {
            key: '',
            appId: '',
            typeName: '通知短信',
            type: '2'
          },
          {
            key: '',
            appId: '',
            typeName: '邮件',
            type: '3'
          },
          // {
          //   key: '',
          //   appId: '',
          //   typeName: '短链',
          //   type: '4'
          // },
          {
            key: '',
            appId: '',
            typeName: '企业ID',
            type: '5'
          },
          // {
          //   key: '',
          //   appId: '',
          //   typeName: '人工外呼',
          //   type: '6'
          // },
          // {
          //   key: '',
          //   appId: '',
          //   typeName: '智能外呼',
          //   type: '7'
          // },
        ],
        "aiMaxConcurrency": 1
      })
    }
  }

  handleOk = () => {
    const {marketingManagementStore, handleCancel, title} = this.props
    const {detailsObj} = marketingManagementStore
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        "id": title === 'edit' ? detailsObj?.id : null,
        "groupName": fieldsValue?.groupName,
        "firstApprover": fieldsValue?.firstApprover,
        "secondApprover": fieldsValue?.secondApprover,
        "thirdApprover": fieldsValue?.thirdApprover,
        "groupMember": fieldsValue?.groupMember,
        "aiMaxConcurrency": fieldsValue?.aiMaxConcurrency,
        "config": fieldsValue?.config
      }
      if (title === 'edit') {
        marketingManagementStore.onAddJobAction({...params, id: detailsObj.id}, title).then(res=> {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      } else {
        marketingManagementStore.onAddJobAction({...params}).then(res=> {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      }
    }).catch(() => {})
  }
  onChangeUsers = (value) => {
    this.setState({
      users: value.toString(),
    })
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  onChangeOneVal=(val)=> {
    if(val) {
      this.setState({
        oneVal: val,
        twoVal: undefined
      })
    } else {
      this.setState({
        oneVal: undefined,
        twoVal: undefined
      })
    }
    this.formRef.current.setFieldsValue({
      secondApprover: undefined,
      thirdApprover: undefined
    })
  }
  onChangeTwoVal=(val)=> {
    this.setState({
      twoVal: val
    })
    this.formRef.current.setFieldsValue({
      thirdApprover: undefined
    })
  }
  render() {
    const { marketingManagementStore, addModalVisible, handleCancel, title, t } = this.props
    const { auditLogsUserList } = marketingManagementStore
    return (
      <>
        <Modal
          title={title === 'edit' ? t(`marketingManagement.editTitle`) : t(`marketingManagement.addTitle`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width={'40%'}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk} >{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row gutter={[10, 10]}>
              <Col span={12}>
                <Form.Item name="groupName" label={t(`marketingManagement.groupName`)} rules={[{
                  required: true,
                  message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.groupName`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\]*$/)
                }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="firstApprover" label={t(`marketingManagement.oneApprover`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.oneApprover`)}`}]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  } onChange={this.onChangeOneVal}>
                    {auditLogsUserList?.map(item => (<Select.Option key={item.shortName} value={item.shortName}>{item.shortName}</Select.Option>))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="secondApprover" label={t(`marketingManagement.twoApprover`)}
                  rules={[{required: false, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.twoApprover`)}`}]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  } onChange={this.onChangeTwoVal} disabled={!this.state.oneVal}>
                    {auditLogsUserList?.map(item => (<Select.Option key={item.shortName} value={item.shortName}>{item.shortName}</Select.Option>))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="thirdApprover" label={t(`marketingManagement.threeApprover`)}
                  rules={[{required: false, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.threeApprover`)}`}]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  } disabled={!this.state.twoVal}>
                    {auditLogsUserList?.map(item => (<Select.Option key={item.shortName} value={item.shortName}>{item.shortName}</Select.Option>))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="groupMember" label={t(`marketingManagement.groupUser`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.groupUser`)}`}]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showArrow mode="multiple" maxTagCount="responsive" maxTagTextLength={10} showSearch filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  } onChange={this.onChangeUsers}>
                    {auditLogsUserList?.map(item => (<Select.Option key={item.shortName} value={item.shortName}>{item.shortName}</Select.Option>))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                {this.state.users}
              </Col>
              <Col span={24}>
                <div>
                  <span style={{ color: '#ff4d4f', fontSize: '14px', marginRight: '4px', fontFamily: 'SimSun, sans-serif', fontWeight: 'normal' }}>*</span>
                  {t(`marketingManagement.basicConfig`)}
                </div>
              </Col>
              <Col span={24}>
                <Form.List name="config">
                  {(fields, { add, remove }) => (
                    <>
                      <Table dataSource={fields} pagination={false} className="searchResult formListTable" rowKey="type" rowClassName={this.getRowClassName}>
                        <Table.Column title={t(`marketingManagement.marketingType`)} dataIndex="type" key="type" render={(text, row, index) => {
                          return (
                            <Form.Item name={[row.name, 'typeName']}>
                              <Input disabled />
                            </Form.Item>
                          )
                        }} />
                        <Table.Column title={t(`marketingManagement.marketingAppId`)} dataIndex="appId" key="appId" render={(text, row, index) => {
                          return (
                            <Form.Item name={[row.name, 'appId']} rules={[{
                              required: true,
                              message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.marketingAppId`)} ${t(`general.withoutSpecialChats`)}`,
                              pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                            }]}>
                              <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} />
                            </Form.Item>
                          )
                        }}/>
                        <Table.Column title={t(`marketingManagement.marketingKey`)} dataIndex="key" key="key" render={(text, row, index) => {
                          return (
                            <Form.Item name={[row.name, 'key']} rules={[{
                              required: row.key<3,
                              message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.marketingKey`)} ${t(`general.withoutSpecialChats`)}`,
                              pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                            }]}>
                              <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} />
                            </Form.Item>
                          )
                        }}/>
                      </Table>
                    </>
                  )}
                </Form.List>
              </Col>
              <Col span={24}>
                <Form.Item name="aiMaxConcurrency" label={t(`outboundCall.maxConcurrentCalls`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`outboundCall.maxConcurrentCalls`)}`}]}
                >
                  <InputNumber min={1} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
